import { FC } from 'react'

import { useForm } from '@tanstack/react-form'
import { useMutation } from '@tanstack/react-query'
import { useNavigate } from '@tanstack/react-router'
import { routes } from 'commons/constants/routes'
import { Request } from 'commons/utils/request'
import { DatePicker, Dialog, DialogFace, DialogFooterActions, FF, Info, handleFormSubmissionError } from 'ui/components'
import { Col, FormRow } from 'ui/themes/globalStyles'

type HRRPayload = { companyId: number; endDate: string | null; startDate: string | null }

export const AddDialog: FC<{ onClose: () => void; companyId: number; companyName: string }> = (props) => {
  const { onClose, companyId, companyName } = props
  const navigate = useNavigate()

  const { mutate, isPending } = useMutation<{ id: number }, Error, HRRPayload>({
    mutationFn: (opts) => Request.post(Request.urls.bank.hrr, opts),
    onSuccess: (data) => {
      if (data.id) {
        navigate({ to: routes.bank.hrr.details, params: { id: data.id.toString() } })
      }
    },
    onError: (error) => {
      handleFormSubmissionError(error, formApi)
    }
  })

  const formApi = useForm({
    defaultValues: { companyId, startDate: null, endDate: null } as HRRPayload,
    onSubmit: ({ value }) => mutate(value)
  })

  return (
    <Dialog
      id="add-hrr-dialog"
      onClose={onClose}
      face={DialogFace.PRIMARY}
      title="Add New High-Risk Review"
      footerActions={[DialogFooterActions.ADD, DialogFooterActions.CANCEL]}
      onSubmit={formApi.handleSubmit}
      isSubmitting={isPending}
    >
      <div style={{ padding: '30px 40px' }}>
        <Info label="Company">{companyName}</Info>
        <FormRow>
          <Col>
            <formApi.Field
              name="startDate"
              children={(filesField) => (
                <FF
                  field={filesField}
                  label="Start Date"
                  input={(inputProps) => <DatePicker {...inputProps} required />}
                />
              )}
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col>
            <formApi.Field
              name="endDate"
              children={(filesField) => (
                <FF
                  field={filesField}
                  label="End Date"
                  input={(inputProps) => <DatePicker {...inputProps} required />}
                />
              )}
            />
          </Col>
        </FormRow>
      </div>
    </Dialog>
  )
}
